const setLoadingClinics = (state, loading) => {
  state.loadingClinics = loading
}

const setClinics = (state, clinics) => {
  state.clinics = clinics
}

const setUnity = (state, unity) => {
  state.unity = unity
}

const setChatMessageSettings = (state, chatMessageSettings) => {
  state.chatMessageSettings = chatMessageSettings
}

const setLoadingChatMessageSettings = (state, loading) => {
  state.loadingChatMessageSettings = loading
}

export default {
  setLoadingClinics,
  setClinics,
  setUnity,
  setChatMessageSettings,
  setLoadingChatMessageSettings
}
